module.exports = __webpack_public_path__ + "static/media/main-fr.636d6c79.webp";